import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowUp } from "lucide-react";

export default function BackToTopButton(props) {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleGoToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <button className={`${classes.backToTopButton} ${isVisible ? classes.visible : classes.hidden}`} onClick={() => handleGoToTop()}>
      <label className={classes.button__label}>Back to top</label>
      <ArrowUp className={classes.arrowIcon} />
    </button>
  );
}

const useStyles = makeStyles(() => ({
  backToTopButton: {
    height: "32px",
    width: "fit-content",

    display: "flex",
    alignItems: "center",
    gap: "4px",

    position: "fixed",
    bottom: "32px",
    left: "calc(50%)",
    transform: "translateX(-50%)",

    borderRadius: "16px",

    backgroundColor: "#C3996B",
    color: "#F8F8F8",
    border: "1px solid #B18B61",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",

    padding: "0px 8px 0px 16px",

    cursor: "pointer",

    transition: "opacity 0.3s ease, transform 0.3s ease",

    "&:hover": {
      cursor: "pointer",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
      backgroundColor: "#B18B61",
      borderColor: "#C3996B",
      transform: "translateX(-50%) translateY(-4px)", // Slightly lift the button on hover
    },
  },

  visible: {
    opacity: 1,
    transform: "translateX(-50%) translateY(0)",
  },

  hidden: {
    opacity: 0,
    transform: "translateX(-50%) translateY(20px)",
    pointerEvents: "none", // Prevent interaction when hidden
  },

  button__label: {
    fontSize: "16px",
    margin: "0px",
    cursor: "pointer",
  },

  arrowIcon: {
    width: "16px",
    height: "16px",
  },
}));
